/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { organisations_AbsenceDueDaysRequest } from './organisations_AbsenceDueDaysRequest';
export type organisations_UpdateAbsenceSettingsRequest = {
    certificateDueDay: organisations_AbsenceDueDaysRequest;
    certificateMode: organisations_UpdateAbsenceSettingsRequest.certificateMode;
    certificateRetentionMonths: number;
};
export namespace organisations_UpdateAbsenceSettingsRequest {
    export enum certificateMode {
        UPLOAD = 'UPLOAD',
        EAU = 'EAU',
    }
}

